// extracted by mini-css-extract-plugin
export var content = "_sf-1";
export var wrapper = "_sf-0";